/**
 * Authorization utilities for checking user permissions
 */

/**
 * Checks if user has Super User privileges
 * @param {Object} user - User object from cookies/auth
 * @returns {boolean}
 */
export const isSuperUser = (user) => {
  return user && user.isSuperUser === true;
};

/**
 * Checks if user has Product Team privileges
 * @param {Object} user - User object from cookies/auth
 * @returns {boolean}
 */
export const isProductTeam = (user) => {
  return user && user.isProductTeam === true;
};

/**
 * Checks if user can access super user analytics (Super User OR Product Team)
 * @param {Object} user - User object from cookies/auth
 * @returns {boolean}
 */
export const canAccessSuperUserAnalytics = (user) => {
  return isSuperUser(user) || isProductTeam(user);
};

/**
 * Checks if user has Admin privileges
 * @param {Object} user - User object from cookies/auth
 * @returns {boolean}
 */
export const isAdmin = (user) => {
  return user && (user.isAdmin === true || user.isSuperUser === true);
};
